import { useState } from "react";
import Colors from "../../config/Colors";
import CustomText from "../CustomText";
import {
  LiveScoreType,
  mapAbbrToLogo,
  mapAbbrToLogoWithURL,
  QuestionTypeName,
} from "../../types/type";
import Trophy from "../../assets/TrophyIcon.svg";
import Run from "../../assets/RunIcon.svg";
import Wicket from "../../assets/WicketIcon.svg";
import { formatAnswer, formatQuestionWording } from "../utils";
import { UserPick } from "../../services";

interface ContainerType {
  match: UserPick;
  number: number;
  // liveMatch: boolean;
}

const LiveMatchContainer = ({ match, number }: ContainerType) => {
  const [visible, setVisible] = useState(true);
  let numberOfPredictions = match.benchmark_value;
  let predictedAnswer = match.is_over;
  let currentScore = match?.actual_value;
  let answered = match.actual_value
    ? match.actual_value > match.benchmark_value === match.is_over
      ? true
      : false
    : false;
  let type: QuestionTypeName = match.question_type_name;
  let primaryLogo = match.home_team_abbreviation;
  let secondaryLogo = match.away_team_abbreviation;
  let icon = (
    <img
      src={type === "WINNING_TEAM" ? Trophy : type === "RUNS" ? Run : Wicket}
      style={{ width: type === "RUNS" ? 50 : 45, objectFit: "contain" }}
      alt=""
      className="otherLiveMatchContainerIcon"
    />
  );
  let questionFormat = formatQuestionWording({ type: type });
  let question =
    questionFormat.first +
    " " +
    questionFormat.middle +
    " " +
    questionFormat.last;

  return (
    <div
      onClick={() => setVisible(!visible)}
      style={{
        backgroundColor: "white",
        boxShadow: "0px 5px 20px #eee",
        borderRadius: 10,
        marginTop: 30,
        width: "90%",
        alignItems: "center",
        position: "relative",
      }}
      className="cardLiveMatchContainer"
    >
      <div
        style={{
          position: "absolute",
          top: type === "WINNING_TEAM" ? -30 : type === "RUNS" ? -30 : -20,
          right: 10,
        }}
      >
        {icon}
      </div>

      <center>
        <div style={{ padding: 10, paddingTop: 20, textAlign: "left" }}>
          <CustomText weight="600" color={Colors.primary} size={"xsmall"}>
            Q{number + 1}.
            {formatQuestionWording({ type: match.question_type_name }).first}{" "}
            {formatQuestionWording({ type: match.question_type_name }).middle}{" "}
            {formatQuestionWording({ type: match.question_type_name }).last}
          </CustomText>
          <div style={{ width: "100%", display: "flex", marginTop: "2%" }}>
            <div
              style={{
                justifyContent: "center",
                background: "linear-gradient(45deg,white,#D6DAF2)",
                width: "50%",
                padding: 5,
                marginRight: "0.5%",
                display: "grid",
                textAlign: "center",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <CustomText
                  children={"Your Pick"}
                  color={Colors.primary}
                  size={"xxsmall"}
                />
              </div>

              {match.question_type_name === "WINNING_TEAM" && (
                <center>
                  <img
                    src={
                      match.is_over === true
                        ? mapAbbrToLogoWithURL(match, false).logo
                        : match.is_over === false
                        ? mapAbbrToLogoWithURL(match, true).logo
                        : ""
                    }
                    style={{ width: 30 }}
                    alt={""}
                  />
                </center>
              )}
              {match.question_type_name !== "WINNING_TEAM" && (
                <div
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    display: "flex",
                    textAlign: "right",
                  }}
                >
                  {match.is_over !== null ? (
                    <CustomText
                      children={
                        formatAnswer({
                          question: match,
                          above: match.is_over,
                          isTeam: false,
                        }).buttonText
                      }
                      color={Colors.primary}
                      size={"xsmall"}
                      weight={"700"}
                    />
                  ) : (
                    <CustomText
                      children={"Not Answered"}
                      color={Colors.primary}
                      size={"small"}
                      weight={"500"}
                    />
                  )}
                </div>
              )}
            </div>
            <div
              style={{
                justifyContent: "center",
                background: "linear-gradient(-45deg,white,#D6DAF2)",
                width: "50%",
                marginLeft: "0.5%",
                padding: 5,
                display: "grid",
                textAlign: "center",
              }}
            >
              <div>
                {match.question_type_name === "WINNING_TEAM" && (
                  <CustomText
                    children={"Actual"}
                    color={Colors.primary}
                    size={"xsmall"}
                  />
                )}
                {match.question_type_name !== "WINNING_TEAM" && (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <CustomText
                      children={"Actual"}
                      color={Colors.primary}
                      size={"xsmall"}
                      style={{ alignSelf: "center" }}
                    />
                    <br />
                    <CustomText
                      children={
                        match.actual_value
                          ? formatQuestionWording({
                              type: match.question_type_name,
                            }).middle
                          : "Awaiting Result"
                      }
                      weight="700"
                      color={Colors.primary}
                      size={"xsmall"}
                    />
                  </div>
                )}
              </div>

              {match.question_type_name === "WINNING_TEAM" && (
                <>
                  {!match.actual_value ? (
                    <CustomText
                      children={
                        match.actual_value
                          ? formatQuestionWording({
                              type: match.question_type_name,
                            }).middle
                          : "Awaiting Result"
                      }
                      weight="700"
                      color={Colors.primary}
                      size={"xsmall"}
                    />
                  ) : (
                    <img
                      src={
                        match.is_over === true
                          ? mapAbbrToLogoWithURL(match, false).logo
                          : match.is_over === false
                          ? mapAbbrToLogoWithURL(match, false).logo
                          : ""
                      }
                      style={{ width: 30 }}
                      alt={""}
                    />
                  )}
                </>
              )}
              {match.actual_value &&
                match.question_type_name !== "WINNING_TEAM" && (
                  <div
                    style={{
                      alignContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <CustomText
                      children={
                        formatAnswer({
                          question: match,
                          above:
                            match.actual_value > match.benchmark_value
                              ? true
                              : false,
                          isTeam: false,
                          isPlus: true,
                        }).buttonText
                      }
                      color={Colors.primary}
                      weight={"500"}
                      size={"small"}
                    />
                  </div>
                )}
            </div>
          </div>
        </div>
      </center>
    </div>
  );
};

export default LiveMatchContainer;
